import {
  MediaQueries
} from 'UI/'

export default theme => ({
  container: {
    marginTop: 128,
    marginBottom: 95
  },
  leftMotif: {
    position: 'absolute',
    left: 60,
    top: 0,
    backgroundColor: theme.primary[0],
    borderRadius: '0 0 50px 50px',
    height: 57,
    width: 99,
    opacity: 0.05
  },
  rightMotif: {
    position: 'absolute',
    right: 125,
    bottom: 0,
    backgroundColor: theme.primary[0],
    borderRadius: '50px 50px 0 0',
    height: 57,
    width: 99,
    opacity: 0.05
  },
  paper: {
    position: 'relative',
    padding: '40px 98px 40px 98px',
    width: '100%',
    backgroundColor: theme.neutral[0],
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 86,
    marginBottom: 32,
    borderRadius: 8
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  rowStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 6
  },
  iconStyle: {
    color: theme.secondary[0],
    fontSize: 12,
    marginRight: 7
  },
  imageStyle: {
    height: 345,
    width: 209
  },
  [`${MediaQueries.tablet}`]: {
    leftMotif: {
      height: 56,
      width: 57,
      left: 30,
      top: 0
    },
    imageStyle: {
      height: 268,
      width: 162
    },
    rightMotif: {
      height: 186,
      width: 99,
      right: 52,
      bottom: 0
    },
    paper: {
      padding: 24,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 40
    },
    row: {
      gap: 16
    },
    container: {
      marginTop: 64,
      marginBottom: 64
    },
    buttonStyle: {
      width: '100% !important',
      height: '54px !important'
    }
  },
  [`${MediaQueries.mobile}`]: {
    paper: {
      padding: 24,
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
    imageStyle: {
      height: 268,
      width: 162
    },
    leftMotif: {
      height: 56,
      width: 57,
      left: 30,
      top: 0
    },
    rightMotif: {
      height: 186,
      width: 99,
      right: 52,
      bottom: 0
    },
    buttonStyle: {
      width: '100% !important',
      height: '54px !important'
    },
    row: {
      gap: 16
    },
    container: {
      marginTop: 64,
      marginBottom: 64
    }
  }
})
